import { createTheme, ThemeProvider } from "@mui/material/styles";

const m3Theme = createTheme({
  palette: {
    primary: { main: "#10172B", light: "#d9e2f9", dark: "#001b3e", contrastText: "#ffffff" },
    secondary: { main: "#71AE4D", light: "#d1f0bc", dark: "#0e3400", contrastText: "#ffffff" },
    background: { default: "#f5f7fa", paper: "#ffffff" },
    text: { primary: "#1a1c1e", secondary: "#43474e" },
    error: { main: "#ba1a1a" },
  },
  typography: {
    fontFamily: '"Poppins", sans-serif',
    h1: { fontWeight: 700, fontSize: "2.5rem", letterSpacing: "-0.02em" },
    h2: { fontWeight: 600, fontSize: "2rem", letterSpacing: "-0.01em" },
    h3: { fontWeight: 600, fontSize: "1.5rem" },
    h4: { fontWeight: 500, fontSize: "1.25rem" },
    body1: { fontSize: "1rem", lineHeight: 1.5 },
    body2: { fontSize: "0.875rem", lineHeight: 1.43 },
    button: { fontWeight: 500, letterSpacing: "0.01em", textTransform: "none" },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 9999,
          padding: "8px 24px",
          fontWeight: 500,
          textTransform: "none",
        },
        containedPrimary: {
          "&:hover": { boxShadow: "0 2px 6px 2px rgba(0,0,0,0.10), 0 4px 8px 0px rgba(0,0,0,0.06)" },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "var(--md-sys-elevation-level1)",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 4,
          },
        },
      },
    },
  },
});

export default function M3ThemeProvider({ children }) {
  return <ThemeProvider theme={m3Theme}>{children}</ThemeProvider>;
}
